import { render, staticRenderFns } from "./UUID.vue?vue&type=template&id=3a4fcdf5&scoped=true"
import script from "./UUID.vue?vue&type=script&lang=ts"
export * from "./UUID.vue?vue&type=script&lang=ts"
import style0 from "./UUID.vue?vue&type=style&index=0&id=3a4fcdf5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4fcdf5",
  null
  
)

export default component.exports